import { useT } from "../i18n";

// Flag SVGs — kept tiny and inline so they render without external assets.
const FLAGS = {
    ro: (
        <svg viewBox="0 0 3 2" className="w-full h-full">
            <rect width="1" height="2" x="0" fill="#002B7F" />
            <rect width="1" height="2" x="1" fill="#FCD116" />
            <rect width="1" height="2" x="2" fill="#CE1126" />
        </svg>
    ),
    it: (
        <svg viewBox="0 0 3 2" className="w-full h-full">
            <rect width="1" height="2" x="0" fill="#008C45" />
            <rect width="1" height="2" x="1" fill="#F4F5F0" />
            <rect width="1" height="2" x="2" fill="#CD212A" />
        </svg>
    ),
    en: (
        <svg viewBox="0 0 60 30" className="w-full h-full">
            <clipPath id="ukclip">
                <path d="M0,0 v30 h60 v-30 z" />
            </clipPath>
            <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
            <g clipPath="url(#ukclip)">
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    ),
};

const ORDER = ["ro", "it", "en"];

export default function LangSwitcher({ compact = false }) {
    const { lang, setLang } = useT();
    return (
        <div className="flex items-center gap-1.5" data-testid="lang-switcher">
            {ORDER.map((code) => {
                const active = lang === code;
                const size = compact ? 22 : 26;
                return (
                    <button
                        key={code}
                        onClick={() => setLang(code)}
                        aria-label={code.toUpperCase()}
                        data-testid={`lang-${code}`}
                        className="btn-press rounded-full overflow-hidden flex items-center justify-center"
                        style={{
                            width: size,
                            height: size,
                            border: active ? "2px solid var(--text)" : "2px solid var(--border)",
                            opacity: active ? 1 : 0.55,
                            transition: "opacity 150ms ease, transform 150ms ease",
                            transform: active ? "scale(1.08)" : "scale(1)",
                            background: "var(--bg)",
                        }}
                    >
                        <span className="block" style={{ width: "100%", height: "100%" }}>
                            {FLAGS[code]}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
